class Customer.Methods.TicketCounterCalculator

  constructor: (@ticket) ->
    @slas = Keepcon.ticketSlas
    @calculator = new Customer.Methods.DateDifferenceCalculator(@offsetTimeFromServer())

  firstAssignationCounter: =>
    @counterFor('first_assignation_date', 0, 100)

  lastAssignationCounter: =>
    @counterFor('last_assignation_date', 0, 100)

  firstOfTheLastInteractionsCounter: =>
    @reverseCounterFor('first_of_the_last_interactions_date', (@slas.reply_time * 1000) , 75)

  counterFor: (key, threshold, alertPercentage) =>
    dateFrom = @ticket.getDateMetrics()[key]['from']
    dateTo = @ticket.getDateMetrics()[key]['to']
    if dateTo
      difference = @calculator.differenceFromTo(dateFrom, dateTo, threshold)
    else
      difference = @calculator.differenceTillNow(dateFrom, threshold)
    @genericCounter(difference, alertPercentage)

  reverseCounterFor: (key, threshold, alertPercentage) =>
    dateFrom = @ticket.getDateMetrics()[key]['from']
    dateTo = @ticket.getDateMetrics()[key]['to']
    if dateTo
      difference = @calculator.reverseDifferenceFromTo(dateFrom, dateTo, threshold)
    else
      difference = @calculator.reverseDifferenceTillNow(dateFrom, threshold)
    @genericCounter(difference, alertPercentage)

  genericCounter: (difference, alertPercentage) =>
    alertLevel = @alertForDifference(difference.thresholdPercentage, alertPercentage)
    {
      difference: difference.standarizedDifference
      alert: alertLevel
    }

  alertForDifference: (thresholdPercentage, alertPercentage) =>
    if thresholdPercentage >= 100
      return "high"
    else if thresholdPercentage >= alertPercentage
      return "medium"
    else
      "low"

  offsetTimeFromServer: ->
    remote = $.ajax
                method: 'GET'
                async: false
                cache: false
                timeout: 3000
                url: '/customer/date_time_from_server'
    return (new Date(remote.responseJSON.now) - new Date())
